import { render } from "./CryptoPrice.vue?vue&type=template&id=c97f9430"
import script from "./CryptoPrice.vue?vue&type=script&lang=js"
export * from "./CryptoPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__